import useToggle from '@alltrails/shared/hooks/useToggle';
import Modal from 'components/Modal';
import Typography from 'components/Typography';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import Link from '@alltrails/shared/denali/components/Link';
import * as styles from './OurLeadershipCard.module.scss';
import { Leader } from './OurLeadershipTeam';

export default function OurLeadershipCard({ leader }: { leader: Leader }) {
  const [isOpen, toggle] = useToggle();

  return (
    <div className={styles.card}>
      {/* Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Rebrand%E2%80%93Press%2FAbout%2F404?node-id=1701%3A11787&t=eucdQ5QfGXKB0ZUE-4 */}
      <Modal isOpen={isOpen} onRequestClose={toggle}>
        <div className={styles.modal}>
          <picture>
            <source srcSet={leader.photoAvif} type="image/avif" />
            <source srcSet={leader.photoWebp} type="image/webp" />
            <img alt="" src={leader.photoJpg} className={styles.img} loading="lazy" />
          </picture>
          <Typography component="div" variant="heading400">
            {leader.name}
            <br />
            <span className={styles.title}>{leader.title}</span>
          </Typography>
          <div>
            <Typography className={styles.bio} component="p" variant="paragraph100">
              {leader.bio1}
            </Typography>
            <Typography component="p" variant="paragraph100">
              {leader.bio2}
            </Typography>
          </div>
        </div>
      </Modal>
      <picture>
        <source srcSet={leader.photoAvif} type="image/avif" />
        <source srcSet={leader.photoWebp} type="image/webp" />
        <img alt="" className={styles.img} src={leader.photoJpg} loading="lazy" />
      </picture>
      <Typography className={styles.name} component="div" variant="heading300">
        {leader.name}
        <br />
        <span className={styles.title}>{leader.title}</span>
      </Typography>
      <div className={styles.pronouns}>{leader.pronouns}</div>
      <Link
        onClick={() => {
          toggle();
        }}
      >
        <FormattedMessage defaultMessage="Full bio" />
      </Link>
      {leader.contact && (
        <Link className={styles.contact} href={leader.contact} target="_blank">
          <FormattedMessage defaultMessage="Contact me" />
        </Link>
      )}
    </div>
  );
}
